import { render } from "./show_avatar.vue?vue&type=template&id=d737d6c0"
import script from "./show_avatar.vue?vue&type=script&lang=js"
export * from "./show_avatar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zekarim/Documents/HEIG/roesti-quiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__